module.exports = __webpack_public_path__ + "img/sentra6.fd84ee46.jpeg";